import { useQuery } from "@tanstack/react-query";
import { getRecentDealCount } from "@/api";
import { DashboardData } from "@/types";

export const useRecentDealCount = () => {
  const query = useQuery<DashboardData>({
    queryKey: ["recentDealCount"],
    queryFn: () => getRecentDealCount(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || null,
  }
};